import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledLayout = styled('div', {
  static: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 1200,
  },
});
export const PageLayout = ({ className, ...props }) => {
  return <StyledLayout {...props} className={className} />;
};

PageLayout.propTypes = {
  className: PropTypes.string,
};

PageLayout.defaultProps = {
  className: null,
};
